import React, { useState, useRef, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  TextField,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  Avatar,
} from "@mui/material";
import {
  Facebook,
  Instagram,
  YouTube,
  Twitter,
  Mail,
  AccountCircle,
} from "@mui/icons-material";
import API_BASE_URL from "../../utils/api";

import { Link, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import cdhLogo from "../../assets/cdhLogo.png";
import HeroSection from "../HeroSection/HeroSection";
import API_URL from "../../config";
import axios from "axios";
import { useAuth } from "../Context/AuthContext";

const Header = ({ activeMenu, setActiveMenu, title }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [communityInitiativesOpen, setCommunityInitiativesOpen] =
    useState(false);
  const [summerResidenciesOpen, setSummerResidenciesOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [summerWorkshop2025Open, setSummerWorkshop2025Open] = useState(false);
  const [summerWorkshop2026Open, setSummerWorkshop2026Open] = useState(false);
  const [summerWorkshop2027Open, setSummerWorkshop2027Open] = useState(false);

  const [dhTutorialsOpen, setDhTutorialsOpen] = useState(false);

  const [mobileResourcesOpen, setMobileResourcesOpen] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const [mobileCommunityInitiativesOpen, setMobileCommunityInitiativesOpen] =
    useState(false);
  const [mobileSummerResidenciesOpen, setMobileSummerResidenciesOpen] =
    useState(false);
  const [mobileUserOpen, setMobileUserOpen] = useState(false);
  const [mobileSummerWorkshop2025Open, setMobileSummerWorkshop2025Open] =
    useState(false);
  const [mobileSummerWorkshop2026Open, setMobileSummerWorkshop2026Open] =
    useState(false);
  const [mobileSummerWorkshop2027Open, setMobileSummerWorkshop2027Open] =
    useState(false);
  const [mobileDhTutorialsOpen, setMobileDhTutorialsOpen] = useState(false);
  const [activeEvent, setActiveEvent] = useState(null);

  const resourcesMenuRef = useRef(null);
  const aboutMenuRef = useRef(null);
  const communityInitiativesMenuRef = useRef(null);
  const summerResidenciesMenuRef = useRef(null);
  const userMenuRef = useRef(null);

  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const canAccessWorkshop2026 = Boolean(user?.workshopAccess2026);

  useEffect(() => {
    const fetchActiveEvent = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/transcribeathon/active`, {
          headers: localStorage.getItem("token")
            ? { Authorization: `Bearer ${localStorage.getItem("token")}` }
            : {},
        });

        setActiveEvent(res.data || null);
      } catch (err) {
        setActiveEvent(null);
      }
    };

    fetchActiveEvent();
  }, []);
  const handleOpenLeaderboardBanner = () => {
    if (!activeEvent?._id) return;
    navigate(`/transcribeathon-events/${activeEvent._id}`);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        resourcesMenuRef.current &&
        !resourcesMenuRef.current.contains(event.target)
      ) {
        setResourcesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        aboutMenuRef.current &&
        !aboutMenuRef.current.contains(event.target)
      ) {
        setAboutOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        communityInitiativesMenuRef.current &&
        !communityInitiativesMenuRef.current.contains(event.target)
      ) {
        setCommunityInitiativesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        summerResidenciesMenuRef.current &&
        !summerResidenciesMenuRef.current.contains(event.target)
      ) {
        setSummerResidenciesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuItemClick = (menu) => {
    setActiveMenu(menu);
    setMobileOpen(false);
    setAboutOpen(false);
    setCommunityInitiativesOpen(false);
    setSummerResidenciesOpen(false);
    setUserOpen(false);
  };
  const toggleSubMenu = (submenuSetter) => {
    submenuSetter((prev) => !prev);
  };
  const closeSubMenus = () => {
    setResourcesOpen(false);
    setAboutOpen(false);
  };

  const toggleResourcesMenu = () => {
    setResourcesOpen(!resourcesOpen);
    setAboutOpen(false);
  };

  const toggleMobileResourcesMenu = () => {
    setMobileResourcesOpen(!mobileResourcesOpen);
  };
  const toggleAboutMenu = () => {
    setAboutOpen(!aboutOpen);
    setResourcesOpen(false);
  };
  const toggleMobileAboutMenu = () => {
    setMobileAboutOpen(!mobileAboutOpen);
  };
  const toggleMobileCommunityInitiativesMenu = () => {
    setMobileCommunityInitiativesOpen(!mobileCommunityInitiativesOpen);
  };
  const toggleMobileSummerResidenciesMenu = () => {
    setMobileSummerResidenciesOpen(!mobileSummerResidenciesOpen);
  };
  const toggleMobileUserMenu = () => {
    setMobileUserOpen(!mobileUserOpen);
  };
  const handleSignOut = async () => {
    await logout();
    setActiveMenu("sign-out");
    setMobileOpen(false);
    navigate("/sign-in");
  };

  const drawer = (
    <Box
      sx={{
        width: 250,
        backgroundColor: "#333333",
        minHeight: "100vh",
        overflowY: "auto",
        color: "#fff",
        boxShadow: "4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
      role="presentation"
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
        <IconButton onClick={handleDrawerToggle}>
          <CloseIcon sx={{ color: "#FFD700" }} />
        </IconButton>
      </Box>

      <Box display="flex" alignItems="center" justifyContent="center">
        <IconButton
          component="a"
          href="mailto:dh@usm.edu"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "#FFD700",
            "&:hover": {
              color: "#444444",
            },
          }}
        >
          <Mail />
        </IconButton>

        <IconButton
          component="a"
          href="https://x.com/i/flow/login?redirect_after_login=%2FDHatUSM"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "#FFD700",
            "&:hover": {
              color: "#444444",
            },
          }}
        >
          <Twitter />
        </IconButton>

        <IconButton
          component="a"
          href="https://www.facebook.com/DHatUSM"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "#FFD700",
            "&:hover": {
              color: "#444444f",
            },
          }}
        >
          <Facebook />
        </IconButton>

        <IconButton
          component="a"
          href="https://www.instagram.com/dhatsouthernmiss/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "#FFD700",
            "&:hover": {
              color: "#444444",
            },
          }}
        >
          <Instagram />
        </IconButton>

        <IconButton
          component="a"
          href="https://www.youtube.com/@CDHatUSM"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "#FFD700",
            "&:hover": {
              color: "#444444",
            },
          }}
        >
          <YouTube />
        </IconButton>
      </Box>
      {/*
      <Box display="flex" alignItems="center" sx={{ gap: 1, p: 2 }}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search..."
          fullWidth
          sx={{
            backgroundColor: "#F5F5F5",
            borderRadius: "5px",
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#FFD700" },
              "&:hover fieldset": { borderColor: "#FFB800" },
              "&.Mui-focused fieldset": { borderColor: "#FFD700" },
            },
          }}
        />
        <IconButton>
          <SearchIcon sx={{ color: "#FFD700" }} />
        </IconButton>
      </Box>
      */}
      <List>
        <ListItemButton
          onClick={() => handleMenuItemClick("home")}
          component={Link}
          to="/"
          sx={{
            backgroundColor: activeMenu === "home" ? "#FFD700" : "transparent",
            color: activeMenu === "home" ? "#111111" : "#FFF",
            borderRadius: "5px",
            marginBottom: "5px",
            "&:hover": { backgroundColor: "#FFD800" },
          }}
        >
          <ListItemText primary="Home" sx={{ color: "#FFF" }} />
        </ListItemButton>
        <ListItemButton onClick={toggleMobileResourcesMenu}>
          <ListItemText primary="Resources" sx={{ color: "#FFF" }} />
          {mobileResourcesOpen ? (
            <ExpandLessIcon sx={{ color: "#FFD700" }} />
          ) : (
            <ExpandMoreIcon sx={{ color: "#FFD700" }} />
          )}
        </ListItemButton>
        <Collapse in={mobileResourcesOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 4 }}>
            <ListItemButton
              onClick={() => handleMenuItemClick("dh")}
              component={Link}
              to="/dh"
              sx={{
                backgroundColor:
                  activeMenu === "dh" ? "#FFD700" : "transparent",
                color: activeMenu === "dh" ? "#111111" : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText
                primary="What are Digital Humanities?"
                sx={{ color: "#FFF" }}
              />
            </ListItemButton>
            <ListItemButton
              onClick={() => handleMenuItemClick("available-tools")}
              component={Link}
              to="/mdhh-tools"
              sx={{
                backgroundColor:
                  activeMenu === "available-tools" ? "#FFD700" : "transparent",
                color: activeMenu === "available-tools" ? "#111111" : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText primary="Hub Tools" sx={{ color: "#FFF" }} />
            </ListItemButton>{" "}
            <ListItemButton
              onClick={() => handleMenuItemClick("dh-tutorials")}
              component={Link}
              to="/dh-tutorials"
              sx={{
                backgroundColor:
                  activeMenu === "dh-tutorials" ? "#FFD700" : "transparent",
                color: activeMenu === "dh-tutorials" ? "#111111" : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText primary="DH Tutorials" sx={{ color: "#FFF" }} />
            </ListItemButton>
            <ListItemButton
              onClick={() => handleMenuItemClick("grants")}
              component={Link}
              to="/grants"
              sx={{
                backgroundColor:
                  activeMenu === "grants" ? "#FFD700" : "transparent",
                color: activeMenu === "grants" ? "#111111" : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText primary="Grants" sx={{ color: "#FFF" }} />
            </ListItemButton>
            <ListItemButton
              onClick={() => handleMenuItemClick("conference")}
              component={Link}
              to="/conference"
              sx={{
                backgroundColor:
                  activeMenu === "conference" ? "#FFD700" : "transparent",
                color: activeMenu === "conference" ? "#111111" : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText primary="Conference" sx={{ color: "#FFF" }} />
            </ListItemButton>
            <ListItemButton
              onClick={() => handleMenuItemClick("policies&manuals")}
              component={Link}
              to="/policies"
              sx={{
                backgroundColor:
                  activeMenu === "policies&manuals" ? "#FFD700" : "transparent",
                color: activeMenu === "policies&manuals" ? "#111111" : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText
                primary="Policies and Manuals"
                sx={{ color: "#FFF" }}
              />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton onClick={toggleMobileCommunityInitiativesMenu}>
          <ListItemText
            primary="Community Initiatives"
            sx={{ color: "#FFF" }}
          />
          {mobileCommunityInitiativesOpen ? (
            <ExpandLessIcon sx={{ color: "#FFD700" }} />
          ) : (
            <ExpandMoreIcon sx={{ color: "#FFD700" }} />
          )}
        </ListItemButton>
        <Collapse
          in={mobileCommunityInitiativesOpen}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding sx={{ pl: 4 }}>
            {user ? (
              <>
                <ListItemButton
                  onClick={() => handleMenuItemClick("join-the-initiative")}
                  component={Link}
                  to="/dh-hub"
                  sx={{
                    backgroundColor:
                      activeMenu === "join-the-initiative"
                        ? "#FFD700"
                        : "transparent",
                    color:
                      activeMenu === "join-the-initiative" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText primary="Dashboard" sx={{ color: "#FFF" }} />
                </ListItemButton>
                <ListItemButton
                  onClick={logout}
                  component={Link}
                  to="/sign-in"
                  sx={{
                    backgroundColor:
                      activeMenu === "sign-out" ? "#FFD700" : "transparent",
                    color: activeMenu === "sign-out" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText primary="Sign-out" sx={{ color: "#FFF" }} />
                </ListItemButton>
              </>
            ) : (
              <>
                <ListItemButton
                  onClick={() => handleMenuItemClick("join-the-initiative")}
                  component={Link}
                  to="/dh-hub"
                  sx={{
                    backgroundColor:
                      activeMenu === "join-the-initiative"
                        ? "#FFD700"
                        : "transparent",
                    color:
                      activeMenu === "join-the-initiative" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText
                    primary="Join the Initiative"
                    sx={{ color: "#FFF" }}
                  />
                </ListItemButton>

                <ListItemButton
                  onClick={() => handleMenuItemClick("sign-in")}
                  component={Link}
                  to="/sign-in"
                  sx={{
                    backgroundColor:
                      activeMenu === "sign-in" ? "#FFD700" : "transparent",
                    color: activeMenu === "sign-in" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText primary="Sign-in" sx={{ color: "#FFF" }} />
                </ListItemButton>
              </>
            )}
          </List>
        </Collapse>
        <ListItemButton onClick={toggleMobileSummerResidenciesMenu}>
          <ListItemText primary="Summer Residencies" sx={{ color: "#FFF" }} />
          {mobileSummerResidenciesOpen ? (
            <ExpandLessIcon sx={{ color: "#FFD700" }} />
          ) : (
            <ExpandMoreIcon sx={{ color: "#FFD700" }} />
          )}
        </ListItemButton>
        <Collapse in={mobileSummerResidenciesOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 4 }}>
            <ListItemButton
              onClick={() => handleMenuItemClick("about-the-summer-workshop")}
              component={Link}
              to="/about-summer-workshop-program"
              sx={{
                backgroundColor:
                  activeMenu === "about-the-summer-workshop"
                    ? "#FFD700"
                    : "transparent",
                color:
                  activeMenu === "about-the-summer-workshop"
                    ? "#111111"
                    : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText
                primary="About the Program"
                sx={{ color: "#FFF" }}
              />
            </ListItemButton>

            <ListItemButton
              onClick={() => setMobileSummerWorkshop2027Open((p) => !p)}
            >
              <ListItemText primary="Residency 2027" sx={{ color: "#FFF" }} />
              {mobileSummerWorkshop2027Open ? (
                <ExpandLessIcon sx={{ color: "#FFD700" }} />
              ) : (
                <ExpandMoreIcon sx={{ color: "#FFD700" }} />
              )}
            </ListItemButton>

            <Collapse
              in={mobileSummerWorkshop2027Open}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding sx={{ pl: 4 }}>
                <ListItemButton
                  component={Link}
                  to="/about-summer-workshop-2027"
                  onClick={(e) => {
                    e.stopPropagation();

                    handleMenuItemClick("about-the-summer-workshop-2027");
                  }}
                  sx={{
                    backgroundColor:
                      activeMenu === "about-the-summer-workshop-2027"
                        ? "#FFD700"
                        : "transparent",
                    color:
                      activeMenu === "about-the-summer-workshop-2027"
                        ? "#111111"
                        : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText primary="About" sx={{ color: "#FFF" }} />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/summer-workshop-2027/application"
                  onClick={(e) => {
                    e.stopPropagation();

                    handleMenuItemClick("application");
                  }}
                  sx={{
                    backgroundColor:
                      activeMenu === "application" ? "#FFD700" : "transparent",
                    color: activeMenu === "application" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText primary="Application" sx={{ color: "#FFF" }} />
                </ListItemButton>{" "}
                {/*
                {user?.workshopAccess2026 && (
                  <>
                    <ListItemButton
                      component={Link}
                      to="/summer-workshop-2026/workshop-schedule"
                      onClick={() => {
                        handleMenuItemClick("workshop-schedule-2026");
                        setMobileOpen(false);
                      }}
                    >
                      <ListItemText
                        primary="Workshop Schedule"
                        sx={{ color: "#FFF" }}
                      />
                    </ListItemButton>

                    <ListItemButton
                      component={Link}
                      to="/summer-workshop-2026/workshop-materials"
                      onClick={() => {
                        handleMenuItemClick("workshop-materials-2026");
                        setMobileOpen(false);
                      }}
                    >
                      <ListItemText
                        primary="Workshop Materials"
                        sx={{ color: "#FFF" }}
                      />
                    </ListItemButton>
                  </>
                )}
                <ListItemButton
                  component={Link}
                  to="/summer-workshop-2026/participants"
                  onClick={() => {
                    handleMenuItemClick("workshop-participants");
                    setMobileOpen(false);
                  }}
                >
                  <ListItemText
                    primary="Workshop Participants"
                    sx={{ color: "#FFF" }}
                  />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/summer-workshop-2026/guestSpeakers"
                  onClick={() => {
                    handleMenuItemClick("guestspeakers");
                    setMobileOpen(false);
                  }}
                >
                  <ListItemText
                    primary="Guest Speakers"
                    sx={{ color: "#FFF" }}
                  />
                </ListItemButton>*/}
              </List>
            </Collapse>
            <ListItemButton
              onClick={() =>
                handleMenuItemClick("summer-workshop-2026-archive")
              }
              component={Link}
              to="/summerworkshop-2026-archive"
              sx={{
                backgroundColor:
                  activeMenu === "summer-workshop-2026-archive"
                    ? "#FFD700"
                    : "transparent",
                color:
                  activeMenu === "summer-workshop-2026-archive"
                    ? "#111111"
                    : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText
                primary="Residency 2026 - Archive"
                sx={{ color: "#FFF" }}
              />
            </ListItemButton>
            <ListItemButton
              onClick={() =>
                handleMenuItemClick("summer-workshop-2025-archive")
              }
              component={Link}
              to="/summerworkshop-2025-archive"
              sx={{
                backgroundColor:
                  activeMenu === "summer-workshop-2025-archive"
                    ? "#FFD700"
                    : "transparent",
                color:
                  activeMenu === "summer-workshop-2025-archive"
                    ? "#111111"
                    : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText
                primary="Residency 2025 - Archive"
                sx={{ color: "#FFF" }}
              />
            </ListItemButton>
            {/* 
            <ListItemButton
              onClick={() => setMobileSummerWorkshop2026Open((p) => !p)}
            >
              <ListItemText primary="Summer 2026" sx={{ color: "#FFF" }} />
              {mobileSummerWorkshop2026Open ? (
                <ExpandLessIcon sx={{ color: "#FFD700" }} />
              ) : (
                <ExpandMoreIcon sx={{ color: "#FFD700" }} />
              )}
            </ListItemButton>

            <Collapse
              in={mobileSummerWorkshop2026Open}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding sx={{ pl: 4 }}>
                <ListItemButton
                  component={Link}
                  to="/about-summer-workshop-2026"
                  onClick={() => {
                    handleDrawerToggle();
                    handleMenuItemClick("about-the-summer-workshop-2026");
                    setMobileSummerResidenciesOpen(false);
                    setMobileSummerWorkshop2025Open(false);
                    setMobileSummerWorkshop2026Open(false);
                  }}
                  sx={{
                    backgroundColor:
                      activeMenu === "about-the-summer-workshop-2026"
                        ? "#FFD700"
                        : "transparent",
                    color:
                      activeMenu === "about-the-summer-workshop-2026"
                        ? "#111111"
                        : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText primary="About" sx={{ color: "#FFF" }} />
                </ListItemButton>
              </List>
            </Collapse>

            <ListItemButton
              onClick={() => setMobileSummerWorkshop2025Open((p) => !p)}
            >
              <ListItemText primary="Summer 2025" sx={{ color: "#FFF" }} />
              {mobileSummerWorkshop2025Open ? (
                <ExpandLessIcon sx={{ color: "#FFD700" }} />
              ) : (
                <ExpandMoreIcon sx={{ color: "#FFD700" }} />
              )}
            </ListItemButton>

            <Collapse
              in={mobileSummerWorkshop2025Open}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding sx={{ pl: 4 }}>
                <ListItemButton
                  component={Link}
                  to="/about-summer-workshop-2025"
                  onClick={() => {
                    handleDrawerToggle();
                    handleMenuItemClick("about-the-summer-workshop-2025");
                    setMobileSummerResidenciesOpen(false);
                    setMobileSummerWorkshop2025Open(false);
                    setMobileSummerWorkshop2026Open(false);
                  }}
                  sx={{
                    backgroundColor:
                      activeMenu === "about-the-summer-workshop-2025"
                        ? "#FFD700"
                        : "transparent",
                    color:
                      activeMenu === "about-the-summer-workshop-2025"
                        ? "#111111"
                        : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText primary="About" sx={{ color: "#FFF" }} />
                </ListItemButton>

                <ListItemButton
                  component={Link}
                  to="/summer-workshop-2025/workshop-schedule"
                  onClick={() => {
                    handleDrawerToggle();
                    handleMenuItemClick("workshop-schedule");
                    setMobileSummerResidenciesOpen(false);
                    setMobileSummerWorkshop2025Open(false);
                    setMobileSummerWorkshop2026Open(false);
                  }}
                  sx={{
                    backgroundColor:
                      activeMenu === "workshop-schedule"
                        ? "#FFD700"
                        : "transparent",
                    color:
                      activeMenu === "workshop-schedule" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText
                    primary="Workshop Schedule"
                    sx={{ color: "#FFF" }}
                  />
                </ListItemButton>

                <ListItemButton
                  component={Link}
                  to="/summer-workshop-2025/workshop-materials"
                  onClick={() => {
                    handleDrawerToggle();
                    handleMenuItemClick("workshop-materials");
                    setMobileSummerResidenciesOpen(false);
                    setMobileSummerWorkshop2025Open(false);
                    setMobileSummerWorkshop2026Open(false);
                  }}
                  sx={{
                    backgroundColor:
                      activeMenu === "workshop-materials"
                        ? "#FFD700"
                        : "transparent",
                    color:
                      activeMenu === "workshop-materials" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText
                    primary="Workshop Materials"
                    sx={{ color: "#FFF" }}
                  />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/summer-workshop-2025/application"
                  onClick={() => {
                    handleDrawerToggle();
                    handleMenuItemClick("application");
                    setMobileSummerResidenciesOpen(false);
                    setMobileSummerWorkshop2025Open(false);
                    setMobileSummerWorkshop2026Open(false);
                  }}
                  sx={{
                    backgroundColor:
                      activeMenu === "application" ? "#FFD700" : "transparent",
                    color: activeMenu === "application" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText primary="Application" sx={{ color: "#FFF" }} />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/summer-workshop-2025/FAQs"
                  onClick={() => {
                    handleDrawerToggle();
                    handleMenuItemClick("FAQs");
                    setMobileSummerResidenciesOpen(false);
                    setMobileSummerWorkshop2025Open(false);
                    setMobileSummerWorkshop2026Open(false);
                  }}
                  sx={{
                    backgroundColor:
                      activeMenu === "FAQs" ? "#FFD700" : "transparent",
                    color: activeMenu === "FAQs" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText primary="FAQs" sx={{ color: "#FFF" }} />
                </ListItemButton>
              </List>
            </Collapse>
             */}
          </List>
        </Collapse>

        <ListItemButton onClick={toggleMobileAboutMenu}>
          <ListItemText primary="About" sx={{ color: "#FFF" }} />
          {mobileResourcesOpen ? (
            <ExpandLessIcon sx={{ color: "#FFD700" }} />
          ) : (
            <ExpandMoreIcon sx={{ color: "#FFD700" }} />
          )}
        </ListItemButton>
        <Collapse in={mobileAboutOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 4 }}>
            <ListItemButton
              onClick={() => handleMenuItemClick("about")}
              component={Link}
              to="/about"
              sx={{
                backgroundColor:
                  activeMenu === "about" ? "#FFD700" : "transparent",
                color: activeMenu === "about" ? "#111111" : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText primary="About the Hub" sx={{ color: "#FFF" }} />
            </ListItemButton>

            <ListItemButton
              onClick={() => handleMenuItemClick("usm-cdh")}
              component={Link}
              to="https://www.usmcdh.org/"
              target="_blank"
              sx={{
                backgroundColor:
                  activeMenu === "usm-cdh" ? "#FFD700" : "transparent",
                color: activeMenu === "usm-cdh" ? "#111111" : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText primary="USM-CDH" sx={{ color: "#FFF" }} />
            </ListItemButton>

            <ListItemButton
              onClick={() => handleMenuItemClick("contact-us")}
              component={Link}
              to="/contact-us"
              sx={{
                backgroundColor:
                  activeMenu === "contact-us" ? "#FFD700" : "transparent",
                color: activeMenu === "contact-us" ? "#111111" : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText primary="Contact Us" sx={{ color: "#FFF" }} />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton
          onClick={() => handleMenuItemClick("blogs")}
          component={Link}
          to="/blogs"
          sx={{
            backgroundColor: activeMenu === "blogs" ? "#FFD700" : "transparent",
            color: activeMenu === "blogs" ? "#111111" : "#FFF",
            borderRadius: "5px",
            marginBottom: "5px",
            "&:hover": { backgroundColor: "#FFD800" },
          }}
        >
          <ListItemText primary="Our Blog" sx={{ color: "#FFF" }} />
        </ListItemButton>
        {user?.grantsAccess && (
          <>
            <ListItemButton
              onClick={() => handleMenuItemClick("grants")}
              component={Link}
              to="/Grants-Dashboard"
              sx={{
                backgroundColor:
                  activeMenu === "grants" ? "#FFD700" : "transparent",
                color: activeMenu === "grants" ? "#111111" : "#FFF",
                borderRadius: "5px",
                marginBottom: "5px",
                "&:hover": { backgroundColor: "#FFD800" },
              }}
            >
              <ListItemText primary="Grants Dashboard" sx={{ color: "#FFF" }} />
            </ListItemButton>
          </>
        )}
        {user && (
          <>
            <ListItemButton onClick={toggleMobileUserMenu}>
              <ListItemText primary={user.name} sx={{ color: "#FFF" }} />
              {mobileUserOpen ? (
                <ExpandLessIcon sx={{ color: "#FFD700" }} />
              ) : (
                <ExpandMoreIcon sx={{ color: "#FFD700" }} />
              )}
            </ListItemButton>
            <Collapse in={mobileUserOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pl: 4 }}>
                <ListItemButton
                  onClick={() => handleMenuItemClick("update-profile")}
                  component={Link}
                  to="/edit-profile"
                  sx={{
                    backgroundColor:
                      activeMenu === "update-profile"
                        ? "#FFD700"
                        : "transparent",
                    color: activeMenu === "update-profile" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText
                    primary="Update Profile"
                    sx={{ color: "#FFF" }}
                  />
                </ListItemButton>
                <ListItemButton
                  onClick={logout}
                  component={Link}
                  to="/sign-in"
                  sx={{
                    backgroundColor:
                      activeMenu === "sign-out" ? "#FFD700" : "transparent",
                    color: activeMenu === "sign-out" ? "#111111" : "#FFF",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    "&:hover": { backgroundColor: "#FFD800" },
                  }}
                >
                  <ListItemText primary="Sign-out" sx={{ color: "#FFF" }} />
                </ListItemButton>
              </List>
            </Collapse>
          </>
        )}
      </List>
    </Box>
  );

  return (
    <AppBar position="sticky" color="default" elevation={0}>
      {/* {activeEvent && (
        <Box
          onClick={handleOpenLeaderboardBanner}
          sx={{
            backgroundColor: "#fff7db",
            borderBottom: "1px solid #e5d28a",
            textAlign: "center",
            py: 0.75,
            px: 2,
            position: "sticky",
            top: 0,
            zIndex: 1300,
            cursor: "pointer",
            transition: "background-color 0.2s ease",
            "&:hover": {
              backgroundColor: "#fff1bf",
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#6b4f00",
              fontWeight: 700,
              letterSpacing: "0.15px",
            }}
          >
            Live Transcribeathon: {activeEvent.name} — View leaderboard
          </Typography>
        </Box>
      )} */}
      {/* Top Strip 
     
      <Box sx={{ backgroundColor: "#111111", textAlign: "center", py: 1, position: "sticky", top: 0, zIndex: 999 }}>
    <Typography variant="body2" sx={{ color: "#ffd700", fontWeight: "bold" }}>
    We’re Hiring! Publicity Manager & Events Planner.
    <a href="https://usm.csod.com/ats/careersite/JobDetails.aspx?id=4504&site=1" target="_blank" sx={{ ml: 1, color: "#0056b3" }}>
    Learn More
    </a>
    </Typography>
    </Box>*/}

      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingX: 2,
          alignItems: "center",
        }}
      >
        {/* <Box
          sx={{
            flex: 1, 
            display: "flex",
            justifyContent: "left", 
            position: "relative",
            alignItems: "center",
            marginTop:{xs:"30px", md:"10px"},
            top:"10px"
          }}
        >
          <Typography
            variant="h3"
            fontWeight="bold"
            color="textPrimary"
            sx={{ 
                textTransform: "uppercase", marginTop: "-30px", 
                fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
                letterSpacing: "2px", 
                 
                color: "#333", 
                transition: "all 0.3s ease", 
                "&:hover": { 
                    color: "#FFD700", 
                    },
                     }}
          >
        {title}          </Typography>
        </Box>  */}

        <IconButton
          color="inherit"
          edge="end"
          onClick={handleDrawerToggle}
          sx={{
            display: { xs: "block", lg: "none" },
            right: "15px",
            position: "absolute",
          }}
        >
          <MenuIcon />
        </IconButton>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            gap: { md: 2, lg: 4 },
            display: { xs: "none", lg: "flex" },
            position: "absolute",
            width: "100%",
            bottom: 5,
            zIndex: 10,
          }}
        >
          <Button
            color="inherit"
            onClick={() => handleMenuItemClick("home")}
            component={Link}
            to="/"
            sx={{
              textDecoration: activeMenu === "home" ? "none" : "none",
              borderBottom:
                activeMenu === "home" ? "2px solid #FFD700" : "none",
            }}
          >
            Home
          </Button>

          <Box
            ref={resourcesMenuRef}
            sx={{ position: "relative" }}
            onMouseEnter={() => setResourcesOpen(true)}
            onMouseLeave={() => setResourcesOpen(false)}
          >
            <Button
              color="inherit"
              sx={{
                textDecoration: activeMenu === "resources" ? "none" : "none",
                borderBottom:
                  activeMenu === "resources" ? "2px solid #FFD700" : "none",
              }}
              ref={resourcesMenuRef}
            >
              Resources{" "}
              {resourcesOpen ? (
                <ExpandLessIcon sx={{ color: "#FFD700" }} />
              ) : (
                <ExpandMoreIcon sx={{ color: "#FFD700" }} />
              )}
            </Button>
            <Collapse in={resourcesOpen} timeout="auto" unmountOnExit>
              <Box
                sx={{
                  position: "absolute",
                  top: "35px",
                  left: 0,
                  transform: "translateX(0%)",
                  backgroundColor: "#efefef",
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                  zIndex: 10,
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                  width: "300px",
                }}
              >
                <Button
                  color="inherit"
                  onClick={() =>
                    handleMenuItemClick("what-are-digital-humanities")
                  }
                  component={Link}
                  to="/dh"
                  sx={{
                    textDecoration:
                      activeMenu === "what-are-digital-humanities"
                        ? "none"
                        : "none",
                    borderBottom:
                      activeMenu === "what-are-digital-humanities"
                        ? "2px solid #FFD700"
                        : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  What are "Digital Humanities"?
                </Button>
                <Button
                  color="inherit"
                  onClick={() => handleMenuItemClick("available-tools")}
                  component={Link}
                  to="/mdhh-tools"
                  sx={{
                    textDecoration:
                      activeMenu === "available-tools" ? "none" : "none",
                    borderBottom:
                      activeMenu === "available-tools"
                        ? "2px solid #FFD700"
                        : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  Hub Tools
                </Button>
                <Button
                  color="inherit"
                  onClick={() => handleMenuItemClick("dh-tutorials")}
                  component={Link}
                  to="/dh-tutorials"
                  sx={{
                    textDecoration:
                      activeMenu === "dh-tutorials" ? "none" : "none",
                    borderBottom:
                      activeMenu === "dh-tutorials"
                        ? "2px solid #FFD700"
                        : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  DH Tutorials
                </Button>

                <Button
                  color="inherit"
                  onClick={() => handleMenuItemClick("grants")}
                  component={Link}
                  to="/grants"
                  sx={{
                    textDecoration: activeMenu === "grants" ? "none" : "none",
                    borderBottom:
                      activeMenu === "grants" ? "2px solid #FFD700" : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  Grants
                </Button>
                <Button
                  color="inherit"
                  onClick={() => handleMenuItemClick("conference")}
                  component={Link}
                  to="/conference"
                  sx={{
                    textDecoration:
                      activeMenu === "conference" ? "none" : "none",
                    borderBottom:
                      activeMenu === "conference"
                        ? "2px solid #FFD700"
                        : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  Conference
                </Button>
                <Button
                  color="inherit"
                  onClick={() => handleMenuItemClick("policies&manuals")}
                  component={Link}
                  to="/policies"
                  sx={{
                    textDecoration: activeMenu === "policies" ? "none" : "none",
                    borderBottom:
                      activeMenu === "policies" ? "2px solid #FFD700" : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  Policies and Manuals
                </Button>
              </Box>
            </Collapse>
          </Box>
          <Box
            ref={communityInitiativesMenuRef}
            sx={{ position: "relative" }}
            onMouseEnter={() => setCommunityInitiativesOpen(true)}
            onMouseLeave={() => setCommunityInitiativesOpen(false)}
          >
            <Button
              color="inherit"
              sx={{
                textDecoration:
                  activeMenu === "Community Initiatives" ? "none" : "none",
                borderBottom:
                  activeMenu === "Community Initiatives"
                    ? "2px solid #FFD700"
                    : "none",
              }}
              ref={communityInitiativesMenuRef}
            >
              Community Initiatives{" "}
              {communityInitiativesOpen ? (
                <ExpandLessIcon sx={{ color: "#FFD700" }} />
              ) : (
                <ExpandMoreIcon sx={{ color: "#FFD700" }} />
              )}
            </Button>
            <Collapse
              in={communityInitiativesOpen}
              timeout="auto"
              unmountOnExit
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "35px",
                  left: 0,
                  transform: "translateX(0%)",
                  backgroundColor: "#efefef",
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                  zIndex: 10,
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                  width: "250px",
                }}
              >
                {user ? (
                  <>
                    <Button
                      color="inherit"
                      onClick={() => handleMenuItemClick("join-the-initiative")}
                      component={Link}
                      to="/dh-hub"
                      sx={{
                        textDecoration:
                          activeMenu === "Join-the-initiative"
                            ? "none"
                            : "none",
                        borderBottom:
                          activeMenu === "Join-the-initiative"
                            ? "2px solid #FFD700"
                            : "none",
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      Dashboard
                    </Button>
                    <Button
                      color="inherit"
                      onClick={logout}
                      component={Link}
                      to="/sign-in"
                      sx={{
                        textDecoration:
                          activeMenu === "sign-out" ? "none" : "none",
                        borderBottom:
                          activeMenu === "sign-out"
                            ? "2px solid #FFD700"
                            : "none",
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      Sign-Out
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      color="inherit"
                      onClick={() => handleMenuItemClick("join-the-initiative")}
                      component={Link}
                      to="/dh-hub"
                      sx={{
                        textDecoration:
                          activeMenu === "Join-the-initiative"
                            ? "none"
                            : "none",
                        borderBottom:
                          activeMenu === "Join-the-initiative"
                            ? "2px solid #FFD700"
                            : "none",
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      Join the Initiative
                    </Button>
                    <Button
                      color="inherit"
                      onClick={() => handleMenuItemClick("sign-in")}
                      component={Link}
                      to="/sign-in"
                      sx={{
                        textDecoration:
                          activeMenu === "sign-in" ? "none" : "none",
                        borderBottom:
                          activeMenu === "sign-in"
                            ? "2px solid #FFD700"
                            : "none",
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      Sign-in
                    </Button>
                  </>
                )}
              </Box>
            </Collapse>
          </Box>
          <Box
            ref={summerResidenciesMenuRef}
            sx={{ position: "relative" }}
            onMouseEnter={() => setSummerResidenciesOpen(true)}
            onMouseLeave={() => setSummerResidenciesOpen(false)}
          >
            <Button
              color="inherit"
              sx={{
                textDecoration: activeMenu === "about" ? "none" : "none",
                borderBottom:
                  activeMenu === "resources" ? "2px solid #FFD700" : "none",
              }}
              ref={summerResidenciesMenuRef}
            >
              Summer Residencies{" "}
              {summerResidenciesOpen ? (
                <ExpandLessIcon sx={{ color: "#FFD700" }} />
              ) : (
                <ExpandMoreIcon sx={{ color: "#FFD700" }} />
              )}
            </Button>
            <Collapse in={summerResidenciesOpen} timeout="auto" unmountOnExit>
              <Box
                sx={{
                  position: "absolute",
                  top: "35px",
                  left: 0,
                  transform: "translateX(0%)",
                  backgroundColor: "#efefef",
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                  zIndex: 50,
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                  width: "250px",
                }}
              >
                <Button
                  color="inherit"
                  onClick={() =>
                    handleMenuItemClick("about-the-summer-workshop")
                  }
                  component={Link}
                  to="/about-summer-workshop-program"
                  sx={{
                    textDecoration:
                      activeMenu === "about-the-summer-workshop"
                        ? "none"
                        : "none",
                    borderBottom:
                      activeMenu === "about-the-summer-workshop"
                        ? "2px solid #FFD700"
                        : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  About the Program
                </Button>
                {/*<Button
                  color="inherit"
                  onClick={() =>
                    handleMenuItemClick("about-the-summer-workshop-2026")
                  }
                  component={Link}
                  to="/about-summer-workshop-2026"
                  sx={{
                    textDecoration:
                      activeMenu === "about-the-summer-workshop-2026"
                        ? "none"
                        : "none",
                    borderBottom:
                      activeMenu === "about-the-summer-workshop-2026"
                        ? "2px solid #FFD700"
                        : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  Summer 2026
                </Button> */}
                <Box
                  sx={{ position: "relative" }}
                  onMouseEnter={() => setSummerWorkshop2027Open(true)}
                  onMouseLeave={() => setSummerWorkshop2027Open(false)}
                >
                  <Button
                    color="inherit"
                    onClick={() => handleMenuItemClick("summer-workshop-2027")}
                    component={Link}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    Residency 2027
                    {summerWorkshop2027Open ? (
                      <ExpandLessIcon sx={{ color: "#FFD700" }} />
                    ) : (
                      <ExpandMoreIcon sx={{ color: "#FFD700" }} />
                    )}
                  </Button>

                  <Collapse
                    in={summerWorkshop2027Open}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0, // aligns from hovered item
                        left: "100%", // to the right
                        ml: 0,
                        backgroundColor: "#efefef",
                        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                        zIndex: 20,
                        borderRadius: "4px",
                        display: "flex",
                        flexDirection: "column",
                        padding: "10px",
                        width: "260px",
                      }}
                    >
                      <Button
                        color="inherit"
                        component={Link}
                        to="/about-summer-workshop-2027"
                        sx={{
                          textDecoration:
                            activeMenu === "about-the-summer-workshop-2027"
                              ? "none"
                              : "none",
                          borderBottom:
                            activeMenu === "about-the-summer-workshop-2027"
                              ? "2px solid #FFD700"
                              : "none",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        onClick={() => {
                          setSummerResidenciesOpen(false);
                          handleMenuItemClick("about-the-summer-workshop-2027");
                        }}
                      >
                        About
                      </Button>

                      <Button
                        color="inherit"
                        component={Link}
                        to="/summer-workshop-2027/application"
                        sx={{
                          textDecoration:
                            activeMenu === "application" ? "none" : "none",
                          borderBottom:
                            activeMenu === "application"
                              ? "2px solid #FFD700"
                              : "none",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        onClick={() => {
                          setSummerResidenciesOpen(false);
                          handleMenuItemClick("application");
                        }}
                      >
                        Application
                      </Button>
                      {/* {user?.workshopAccess2026 && (
                        <>
                          <Button
                            color="inherit"
                            component={Link}
                            to="/summer-workshop-2026/workshop-schedule"
                            sx={{
                              textDecoration:
                                activeMenu === "workshop-schedule-2026"
                                  ? "none"
                                  : "none",
                              borderBottom:
                                activeMenu === "workshop-schedule-2026"
                                  ? "2px solid #FFD700"
                                  : "none",
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                            onClick={() => {
                              setSummerResidenciesOpen(false);
                              handleMenuItemClick("workshop-schedule-2026");
                            }}
                          >
                            Workshop Schedule
                          </Button>

                          <Button
                            color="inherit"
                            component={Link}
                            to="/summer-workshop-2026/workshop-materials"
                            onClick={() => {
                              setSummerResidenciesOpen(false);
                              handleMenuItemClick("workshop-materials-2026");
                            }}
                            sx={{
                              textDecoration:
                                activeMenu === "workshop-materials-2026"
                                  ? "none"
                                  : "none",
                              borderBottom:
                                activeMenu === "workshop-materials-2026"
                                  ? "2px solid #FFD700"
                                  : "none",
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            Workshop Materials
                          </Button>
                        </>
                      )}
                      <Button
                        color="inherit"
                        component={Link}
                        to="/summer-workshop-2026/participants"
                        onClick={() => {
                          setSummerResidenciesOpen(false);
                          handleMenuItemClick("workshop-participants");
                        }}
                        sx={{
                          textDecoration:
                            activeMenu === "workshop-participants"
                              ? "none"
                              : "none",
                          borderBottom:
                            activeMenu === "workshop-participants"
                              ? "2px solid #FFD700"
                              : "none",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        Workshop Participants
                      </Button>
                      <Button
                        color="inherit"
                        component={Link}
                        to="/summer-workshop-2026/guestSpeakers"
                        onClick={() => {
                          setSummerResidenciesOpen(false);
                          handleMenuItemClick("guestspeakers");
                        }}
                        sx={{
                          textDecoration:
                            activeMenu === "guestspeakers" ? "none" : "none",
                          borderBottom:
                            activeMenu === "guestspeakers"
                              ? "2px solid #FFD700"
                              : "none",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        Guest Speakers
                      </Button>*/}
                    </Box>
                  </Collapse>
                </Box>
                <Button
                  color="inherit"
                  onClick={() =>
                    handleMenuItemClick("summer-workshop-2026-archive")
                  }
                  component={Link}
                  to="/summerworkshop-2026-archive"
                  sx={{
                    textDecoration:
                      activeMenu === "summer-workshop-2026-archive"
                        ? "none"
                        : "none",
                    borderBottom:
                      activeMenu === "summer-workshop-2026-archive"
                        ? "2px solid #FFD700"
                        : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  Residency 2026 - Archive
                </Button>
                <Button
                  color="inherit"
                  onClick={() =>
                    handleMenuItemClick("summer-workshop-2025-archive")
                  }
                  component={Link}
                  to="/summerworkshop-2025-archive"
                  sx={{
                    textDecoration:
                      activeMenu === "summer-workshop-2025-archive"
                        ? "none"
                        : "none",
                    borderBottom:
                      activeMenu === "summer-workshop-2025-archive"
                        ? "2px solid #FFD700"
                        : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  Residency 2025 - Archive
                </Button>
                {/*  <Box
                  sx={{ position: "relative" }}
                  onMouseEnter={() => setSummerWorkshop2026Open(true)}
                  onMouseLeave={() => setSummerWorkshop2026Open(false)}
                >
                  <Button
                    color="inherit"
                    onClick={() => handleMenuItemClick("summer-workshop-2026")}
                    component={Link}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    Summer 2026
                    {summerWorkshop2026Open ? (
                      <ExpandLessIcon sx={{ color: "#FFD700" }} />
                    ) : (
                      <ExpandMoreIcon sx={{ color: "#FFD700" }} />
                    )}
                  </Button>

                  <Collapse
                    in={summerWorkshop2026Open}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0, // aligns from hovered item
                        left: "100%", // to the right
                        ml: 0,
                        backgroundColor: "#efefef",
                        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                        zIndex: 20,
                        borderRadius: "4px",
                        display: "flex",
                        flexDirection: "column",
                        padding: "10px",
                        width: "260px",
                      }}
                    >
                      <Button
                        color="inherit"
                        component={Link}
                        to="/about-summer-workshop-2026"
                        sx={{
                          textDecoration:
                            activeMenu === "about-the-summer-workshop-2026"
                              ? "none"
                              : "none",
                          borderBottom:
                            activeMenu === "about-the-summer-workshop-2026"
                              ? "2px solid #FFD700"
                              : "none",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        onClick={() => {
                          setSummerResidenciesOpen(false);
                          handleMenuItemClick("about-the-summer-workshop-2026");
                        }}
                      >
                        About
                      </Button>
                    </Box>
                  </Collapse>
                </Box>
               
                <Box
                  sx={{ position: "relative" }}
                  onMouseEnter={() => setSummerWorkshop2025Open(true)}
                  onMouseLeave={() => setSummerWorkshop2025Open(false)}
                >
                  <Button
                    color="inherit"
                    onClick={() => handleMenuItemClick("summer-workshop-2025")}
                    component={Link}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    Summer 2025
                    {summerWorkshop2025Open ? (
                      <ExpandLessIcon sx={{ color: "#FFD700" }} />
                    ) : (
                      <ExpandMoreIcon sx={{ color: "#FFD700" }} />
                    )}
                  </Button>

                  <Collapse
                    in={summerWorkshop2025Open}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0, // aligns from hovered item
                        left: "100%", // to the right
                        ml: 0,
                        backgroundColor: "#efefef",
                        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                        zIndex: 20,
                        borderRadius: "4px",
                        display: "flex",
                        flexDirection: "column",
                        padding: "10px",
                        width: "260px",
                      }}
                    >
                      <Button
                        color="inherit"
                        component={Link}
                        to="/about-summer-workshop-2025"
                        sx={{
                          textDecoration:
                            activeMenu === "about-the-summer-workshop-2025"
                              ? "none"
                              : "none",
                          borderBottom:
                            activeMenu === "about-the-summer-workshop-2025"
                              ? "2px solid #FFD700"
                              : "none",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        onClick={() => {
                          setSummerResidenciesOpen(false);
                          handleMenuItemClick("about-the-summer-workshop-2025");
                        }}
                      >
                        About
                      </Button>

                      <Button
                        color="inherit"
                        component={Link}
                        to="/summer-workshop-2025/workshop-schedule"
                        sx={{
                          textDecoration:
                            activeMenu === "workshop-schedule"
                              ? "none"
                              : "none",
                          borderBottom:
                            activeMenu === "workshop-schedule"
                              ? "2px solid #FFD700"
                              : "none",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        onClick={() => {
                          setSummerResidenciesOpen(false);
                          handleMenuItemClick("workshop-schedule");
                        }}
                      >
                        Workshop Schedule
                      </Button>

                      <Button
                        color="inherit"
                        component={Link}
                        to="/summer-workshop-2025/workshop-materials"
                        sx={{
                          textDecoration:
                            activeMenu === "workshop-materials"
                              ? "none"
                              : "none",
                          borderBottom:
                            activeMenu === "workshop-materials"
                              ? "2px solid #FFD700"
                              : "none",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        onClick={() => {
                          setSummerResidenciesOpen(false);
                          handleMenuItemClick("workshop-materials");
                        }}
                      >
                        Workshop Materials
                      </Button>
                      <Button
                        color="inherit"
                        component={Link}
                        to="/summer-workshop-2025/application"
                        sx={{
                          textDecoration:
                            activeMenu === "application" ? "none" : "none",
                          borderBottom:
                            activeMenu === "application"
                              ? "2px solid #FFD700"
                              : "none",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        onClick={() => {
                          setSummerResidenciesOpen(false);
                          handleMenuItemClick("application");
                        }}
                      >
                        Application
                      </Button>
                      <Button
                        color="inherit"
                        component={Link}
                        to="/summer-workshop-2025/FAQs"
                        sx={{
                          textDecoration:
                            activeMenu === "FAQs" ? "none" : "none",
                          borderBottom:
                            activeMenu === "FAQs"
                              ? "2px solid #FFD700"
                              : "none",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        onClick={() => {
                          setSummerResidenciesOpen(false);
                          handleMenuItemClick("FAQs");
                        }}
                      >
                        FAQs
                      </Button>
                    </Box>
                  </Collapse>
                </Box>
                 */}
              </Box>
            </Collapse>
          </Box>
          <Box
            ref={aboutMenuRef}
            sx={{ position: "relative" }}
            onMouseEnter={() => setAboutOpen(true)}
            onMouseLeave={() => setAboutOpen(false)}
          >
            <Button
              color="inherit"
              sx={{
                textDecoration: activeMenu === "about" ? "none" : "none",
                borderBottom:
                  activeMenu === "resources" ? "2px solid #FFD700" : "none",
              }}
              ref={aboutMenuRef}
            >
              About{" "}
              {aboutOpen ? (
                <ExpandLessIcon sx={{ color: "#FFD700" }} />
              ) : (
                <ExpandMoreIcon sx={{ color: "#FFD700" }} />
              )}
            </Button>
            <Collapse in={aboutOpen} timeout="auto" unmountOnExit>
              <Box
                sx={{
                  position: "absolute",
                  top: "35px",
                  left: 0,
                  transform: "translateX(0%)",
                  backgroundColor: "#efefef",
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                  zIndex: 50,
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                  width: "250px",
                }}
              >
                <Button
                  color="inherit"
                  onClick={() => handleMenuItemClick("about")}
                  component={Link}
                  to="/about"
                  sx={{
                    textDecoration: activeMenu === "about" ? "none" : "none",
                    borderBottom:
                      activeMenu === "about" ? "2px solid #FFD700" : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  About the Hub
                </Button>

                <Button
                  color="inherit"
                  onClick={() => handleMenuItemClick("usm-cdh")}
                  component={Link}
                  to="https://www.usmcdh.org/"
                  target="_blank"
                  sx={{
                    textDecoration: activeMenu === "usm-cdh" ? "none" : "none",
                    borderBottom:
                      activeMenu === "usm-cdh" ? "2px solid #FFD700" : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  USM CDH
                </Button>

                <Button
                  color="inherit"
                  onClick={() => handleMenuItemClick("contact-us")}
                  component={Link}
                  to="/contact-us"
                  sx={{
                    textDecoration:
                      activeMenu === "contact-us" ? "none" : "none",
                    borderBottom:
                      activeMenu === "contact-us"
                        ? "2px solid #FFD700"
                        : "none",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  Contact Us
                </Button>
              </Box>
            </Collapse>
          </Box>
          {user && (
            <Box
              ref={userMenuRef}
              sx={{ position: "absolute", right: 10 }}
              onMouseEnter={() => setUserOpen(true)}
              onMouseLeave={() => setUserOpen(false)}
            >
              <Button
                color="inherit"
                sx={{
                  textDecoration: activeMenu === "User" ? "none" : "none",
                  borderBottom:
                    activeMenu === "User" ? "2px solid #FFD700" : "none",
                }}
                ref={userMenuRef}
              >
                {user.profileImage ? (
                  <>
                    <Avatar
                      src={user.profileImage}
                      alt={user.name}
                      sx={{ width: 32, height: 32, marginRight: "10px" }}
                    />
                    <Typography variant="caption">{user.name}</Typography>
                  </>
                ) : (
                  <AccountCircle />
                )}
                {userOpen ? (
                  <ExpandLessIcon sx={{ color: "#FFD700" }} />
                ) : (
                  <ExpandMoreIcon sx={{ color: "#FFD700" }} />
                )}
              </Button>
              {/*   <IconButton
          sx={{ color:"#FFD700", ml:2}} 
          onClick={()=> navigate("/edit-profile")}>
            <AccountCircle/>
          </IconButton> */}
              <Collapse in={userOpen} timeout="auto" unmountOnExit>
                <Box
                  sx={{
                    position: "absolute",
                    top: "35px",
                    right: 0,
                    transform: "translateX(0%)",
                    backgroundColor: "#efefef",
                    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                    zIndex: 10,
                    borderRadius: "4px",
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px",
                    width: "250px",
                  }}
                >
                  <Button
                    color="inherit"
                    onClick={() => handleMenuItemClick("update-profile")}
                    component={Link}
                    to="/edit-profile"
                    sx={{
                      textDecoration:
                        activeMenu === "Update-profile" ? "none" : "none",
                      borderBottom:
                        activeMenu === "Update-profile"
                          ? "2px solid #FFD700"
                          : "none",
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    Update Profile
                  </Button>
                  <Button
                    color="inherit"
                    onClick={logout}
                    component={Link}
                    to="/sign-in"
                    sx={{
                      textDecoration:
                        activeMenu === "sign-out" ? "none" : "none",
                      borderBottom:
                        activeMenu === "sign-out"
                          ? "2px solid #FFD700"
                          : "none",
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    Sign-Out
                  </Button>
                </Box>
              </Collapse>
            </Box>
          )}
          <Button
            color="inherit"
            onClick={() => handleMenuItemClick("blogs")}
            component={Link}
            to="/blogs"
            sx={{
              textDecoration: activeMenu === "blogs" ? "none" : "none",
              borderBottom:
                activeMenu === "blogs" ? "2px solid #FFD700" : "none",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            Our Blog
          </Button>
          {user?.grantsAccess && (
            <Button
              color="inherit"
              onClick={() => handleMenuItemClick("grants-dashboard")}
              component={Link}
              to="/grants-dashboard"
              sx={{
                textDecoration:
                  activeMenu === "grants-dashboard" ? "none" : "none",
                borderBottom:
                  activeMenu === "grants-dashboard"
                    ? "2px solid #ffd700"
                    : "none",
              }}
            >
              Grants Dashboard
            </Button>
          )}
          {user?.role === "admin" && (
            <Button
              color="inherit"
              onClick={() => handleMenuItemClick("adminView")}
              component={Link}
              to="/Admin-View"
              sx={{
                textDecoration: activeMenu === "adminView" ? "none" : "none",
                borderBottom:
                  activeMenu === "adminView" ? "2px solid #ffd700" : "none",
              }}
            >
              Admin Panel
            </Button>
          )}

          {/*   <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search..."
              value=''
              sx={{
                backgroundColor: "#F5F5F5",
                borderRadius: "5px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#FFD700" },
                  "&:hover fieldset": { borderColor: "#FFB800" },
                  "&.Mui-focused fieldset": { borderColor: "#FFD700" },
                },
              }}
            />
            <IconButton >
              <SearchIcon sx={{ color: "#FFD700" }} />
            </IconButton>
          </Box> */}
        </Box>

        <Box
          display="flex"
          width="100%"
          sx={{
            marginBottom: 5,
            justifyContent: { md: "center", lg: "flex-end" },
            alignItems: "center",
            display: { xs: "none", md: "flex" },
          }}
        >
          <IconButton
            component="a"
            href="mailto:dh@usm.edu"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#FFD700",
              "&:hover": {
                color: "#444444",
              },
            }}
          >
            <Mail />
          </IconButton>

          <IconButton
            component="a"
            href="https://x.com/i/flow/login?redirect_after_login=%2FDHatUSM"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#FFD700",
              "&:hover": {
                color: "#444444",
              },
            }}
          >
            <Twitter />
          </IconButton>

          <IconButton
            component="a"
            href="https://www.facebook.com/DHatUSM"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#FFD700",
              "&:hover": {
                color: "#444444",
              },
            }}
          >
            <Facebook />
          </IconButton>

          <IconButton
            component="a"
            href="https://www.instagram.com/dhatsouthernmiss/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#FFD700",
              "&:hover": {
                color: "#444444",
              },
            }}
          >
            <Instagram />
          </IconButton>

          <IconButton
            component="a"
            href="https://www.youtube.com/@CDHatUSM"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#FFD700",
              "&:hover": {
                color: "#444444",
              },
            }}
          >
            <YouTube />
          </IconButton>
        </Box>
      </Toolbar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          display: { xs: "block", lg: "none" },
        }}
      >
        {drawer}
      </Drawer>

      <Box sx={{ marginTop: 0 }}>
        {activeMenu === "workshop" && <HeroSection title="Workshop" />}
        {activeMenu === "grants" && <HeroSection title="Grants" />}
        {activeMenu === "dh hub" && <HeroSection title="DH Hub Resources" />}
        {activeMenu === "resources" && <HeroSection title="Resources" />}
        {activeMenu === "about" && <HeroSection title="Staff" />}
        {activeMenu === "dh" && (
          <HeroSection title="What is Digital Humanities?" />
        )}
        {activeMenu === "what-are-digital-humanities" && (
          <HeroSection title="What are Digital Humanities" />
        )}
        {activeMenu === "available-tools" && (
          <HeroSection title="Available Tools & the Hub Network" />
        )}
        {activeMenu === "dh-tutorials" && (
          <HeroSection title="Digital Humanities Tutorials" />
        )}
        {activeMenu === "policies&manuals" && <HeroSection title="Policies" />}
        {activeMenu === "usm-cdh" && <HeroSection title="USM CDH" />}
        {activeMenu === "contact-us" && <HeroSection title="Contact Us" />}
        {activeMenu === "about-the-program" && (
          <HeroSection title="About the Program" />
        )}
        {activeMenu === "application" && <HeroSection title="Application" />}
        {activeMenu === "FAQs" && <HeroSection title="FAQs" />}
        {activeMenu === "sign-in" && <HeroSection title="Sign In" />}
        {activeMenu === "join-the-initiative" && (
          <HeroSection title="Join the Initiative" />
        )}
        {activeMenu === "workshop-schedule" && (
          <HeroSection title="Workshop Schedule" />
        )}
        {activeMenu === "workshop-materials" && (
          <HeroSection title="Workshop Materials" />
        )}
        {activeMenu === "sign-out" && <HeroSection title="Sign Out" />}
        {activeMenu === "update-profile" && (
          <HeroSection title="Update Profile" />
        )}
        {activeMenu === "blogs" && <HeroSection title="Blogs" />}
        {activeMenu === "adminView" && <HeroSection title="AdminView" />}
        {activeMenu === "grants-dashboard" && (
          <HeroSection title="GrantsDashboard" />
        )}
        {activeMenu === "summer-workshop-2025" && (
          <HeroSection title="Summer Residency 2025" />
        )}
        {activeMenu === "summer-workshop-2026" && (
          <HeroSection title="Summer Residency 2026" />
        )}{" "}
        {activeMenu === "summer-workshop-2027" && (
          <HeroSection title="Summer Residency 2027" />
        )}
        {activeMenu === "about-the-summer-workshop" && (
          <HeroSection title="About the Summer Residencies" />
        )}
        {activeMenu === "about-the-summer-workshop-2026" && (
          <HeroSection title="About the Summer Residency 2026" />
        )}
        {activeMenu === "summer-workshop-2025-archive" && (
          <HeroSection title="Summer Residency 2025 Archival sources" />
        )}
        {activeMenu === "summer-workshop-2026-archive" && (
          <HeroSection title="Summer Residency 2026 Archival sources" />
        )}
        {activeMenu === "about-the-summer-workshop-2025" && (
          <HeroSection title="About the Summer Residency 2025" />
        )}
        {activeMenu === "about-the-summer-workshop-2027" && (
          <HeroSection title="About the Summer Residency 2027" />
        )}
        {activeMenu === "workshop-schedule-2026" && (
          <HeroSection title="Workshop Schedule" />
        )}
        {activeMenu === "workshop-materials-2026" && (
          <HeroSection title="Workshop Materials" />
        )}
        {activeMenu === "guestspeakers" && (
          <HeroSection title="Guest Speakers" />
        )}
        {activeMenu === "workshop-participants" && (
          <HeroSection title="Workshop Participants" />
        )}
        {activeMenu === "conference" && <HeroSection title="Conference" />}
        {(!activeMenu || activeMenu === "home") && <HeroSection title="Home" />}
      </Box>
    </AppBar>
  );
};

export default Header;
